// extracted by mini-css-extract-plugin
export default {"tooltip":"Cp-z","sharingV2":"Dp-z","sharingIconsV2":"Ep-z","links":"Fp-z","link":"Gp-z","facebookV2":"Hp-z","twitterV2":"Ip-z","pinterestV2":"Jp-z"};